import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShowAllItemsModal from '../../../projects/components/ShowAllItemsModal';

/**
 * Renders the number of prompts a brand was mentioned in for a single platform.
 * The count is a button that, when clicked, expands into a searchable modal
 * listing every prompt behind that count.
 */
export default function PromptCountCell({ prompts = [] }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    if (!prompts.length) return <span>0</span>;

    return (
        <>
            <button type="button" className="button-like-link" onClick={() => setIsOpen(true)}>
                {prompts.length}
            </button>
            {isOpen && (
                <ShowAllItemsModal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    data={prompts.map((prompt) => ({ name: prompt, status: 'active' }))}
                    placeholder={t('ai_tracking.global.search_prompts')}
                />
            )}
        </>
    );
}
